import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { Helpers } from 'app/core/helpers/helpers';
import { BadgePipe } from 'app/core/pipes/badge.pipe';
import { ToastService } from 'app/core/services/toast.service';
import { TasksService } from 'app/modules/tasks/tasks.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-my-tasks',
  standalone: true,
  imports: [RouterLink, DatePipe, MatIconModule, FuseCardComponent, MatProgressSpinnerModule, BadgePipe],
  templateUrl: './my-tasks.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyTasksComponent implements OnInit, OnChanges {
  private Tasks = inject(TasksService);
  private Auth = inject(AuthService);
  private toast = inject(ToastService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  profile: any;
  dataLoader = false;
  error: any;
  myTasks: any = [];
  where: any = [];
  include: any = [];
  columns: any = [];
  order: any = { created_at: 'desc' };
  searchData: any = {
    user_id: { column: 'user_id', operator: '=', value: '' },
    status: { column: 'status', operator: '!=', value: 'Completed' },
  };
  today: Date = new Date();

  @Input() fromDate: any = '';
  @Input() toDate: any = '';
  @Input() associationId: string | null = null;

  ngOnInit() {
    this.today = new Date();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataLoader = true;
    this.profile = this.Auth.profile();
    this.search();
  }

  public search() {
    this.searchData.user_id.value = this.profile.id;
    this.where = Helpers.buildWhere(this.searchData);
    if (this.fromDate) this.where.push({ column: 'created_at', operator: '>=', value: this.fromDate });
    if (this.toDate) this.where.push({ column: 'created_at', operator: '<=', value: this.toDate });
    if (this.associationId) this.where.push({ column: 'association_id', operator: '=', value: this.associationId });
    this.getData();
  }

  public getData() {
    this.dataLoader = true;
    this.myTasks = [];
    this.Tasks.getList({ where: this.where, orderBy: this.order, include: this.include }, 1, 5)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (resp: any) => {
          this.myTasks = resp.record.data;
          this.dataLoader = false;
          this.cdr.markForCheck();
        },
        (error: any) => {
          this.dataLoader = false;
          this.error = error.message || 'An error occurred while getting the tasks';
          this.cdr.markForCheck();
        }
      );
  }

  isOverdue(dueAt: any): boolean {
    if (!dueAt) return false;
    return new Date(dueAt) < this.today;
  }
}
